module.exports = __webpack_public_path__ + "static/img/loading.5780b10b.gif";